import { convertDateFromServer } from "@/helpers/datetime-helper";
import moment from "moment";

const ZOOM_MEETING_TYPE = {
  "A schedule meeting": "zoom_meeting.scheduled_meeting",
  "A recurring meeting with fixed time": "zoom_meeting.recurring_meeting"
};
const REPEAT = {
  daily: "zoom_meeting.daily",
  weekly: "zoom_meeting.weekly"
};
export const scheduleMeetingList = form => {
  let hostInfo = form?.host_zoom_meeting?.host;
  return [
    {
      icon: "person",
      value:
        hostInfo?.full_name + (hostInfo?.email ? " - " + hostInfo?.email : ""),
      name: "zoom_meeting.host"
    },
    {
      icon: "videocam",
      value: ZOOM_MEETING_TYPE[form.zoom_meeting_type],
      name: "zoom_meeting.virtual_meeting_type"
    },
    {
      icon: "watch_later",
      value: form.startDateTime,
      name: "zoom_meeting.start_date_time"
    },
    {
      icon: "watch_later",
      value: form.duration,
      name: "zoom_meeting.duration"
    },
    {
      icon: "watch_later",
      value: form.timezone,
      name: "zoom_meeting.timezone"
    }
  ];
};
export const recurringMeetingList = form => {
  let hostInfo = form?.host_zoom_meeting?.host;
  let list = [
    {
      icon: "person",
      value:
        hostInfo?.full_name + (hostInfo?.email ? " - " + hostInfo?.email : ""),
      name: "zoom_meeting.host"
    },
    {
      icon: "videocam",
      value: ZOOM_MEETING_TYPE[form.zoom_meeting_type],
      name: "zoom_meeting.virtual_meeting_type"
    },
    {
      icon: "watch_later",
      value: REPEAT[form.repeat],
      name: "zoom_meeting.repeat_"
    },
    {
      icon: "watch_later",
      value:
        (Array.isArray(form.repeat_on_key) && form.repeat_on_key.join(", ")) ||
        "",
      name: "zoom_meeting.cycle_days"
    },
    {
      icon: "watch_later",
      value: convertDateFromServer(form.start, "date"),
      name: "common.start_date"
    },
    {
      icon: "watch_later",
      value: convertDateFromServer(form.end, "date"),
      name: "common.end_date"
    },
    {
      icon: "watch_later",
      value: moment(form.from_time, "hh:mm").format("hh:mm A"),
      name: "zoom_meeting.start_time"
    },
    {
      icon: "watch_later",
      value: form.duration,
      name: "zoom_meeting.duration"
    },
    {
      icon: "watch_later",
      value: form.timezone,
      name: "zoom_meeting.timezone"
    }
  ];
  if (form.repeat === "daily") {
    return list.filter(item => item.name !== "zoom_meeting.cycle_days");
  }
  return list;
};
function convertTimezone(time, zone) {
  const moment = require("moment-timezone");
  if (!time) return "";
  return moment(time + " ZZ", "YYYY-MM-DD hh:mm:ss ZZ")
    .tz(zone)
    .format("hh:mm A");
}
export const listCardInformation = info => {
  return [
    {
      name: "zoom_meeting.invitee",
      value: info.invitee,
      icon: "fas fa-users"
    },
    {
      name: "zoom_meeting.present",
      value: info.present,
      icon: "fas fa-users"
    },
    {
      name: "zoom_meeting.absence",
      value: info.absence,
      icon: "fas fa-users"
    },
    {
      name: "zoom_meeting.tardy",
      value: info.tardy,
      icon: "fas fa-users"
    }
  ];
};
